module.exports = __webpack_public_path__ + "img/DSC_2725-xs.38e8753b.png";